import { gql, useQuery } from "@apollo/client";
import { getFetchPolicyOptions } from "api/utils";

interface HasAcceptedTOCQuery {
  loadPreference: string;
}

const HAS_ACCEPTED_QUERY = gql`
  query useGetHasAcceptedTOC {
    loadPreference(prefKey: "termsOfCondition")
  }
`;

export const useGetHasAcceptedTOC = () => {
  const { loading, error, data } = useQuery<HasAcceptedTOCQuery>(
    HAS_ACCEPTED_QUERY,
    {
      ...getFetchPolicyOptions(`useGetHasAcceptedTOC`),
      fetchPolicy: "network-only",
    }
  );

  let hasAccepted: boolean | undefined;

  if (data && data.loadPreference) {
    const rawPreference = data.loadPreference;
    const termsVersion = process.env.REACT_APP_TERMS_USE_VERSION;

    try {
      const parsed = JSON.parse(rawPreference);
      if (parsed && typeof parsed === "object" && "acceptedVersion" in parsed) {
        // Expected shape: { acceptedVersion: string, timeStamp: string }
        hasAccepted =
          (parsed as { acceptedVersion?: string }).acceptedVersion ===
          termsVersion;
      } else if (typeof parsed === "string" || typeof parsed === "number") {
        // Legacy shape: a plain version string/number
        hasAccepted = String(parsed) === termsVersion;
      } else if (typeof parsed === "boolean") {
        // Fallback: a plain boolean (treat true as accepted)
        hasAccepted = parsed;
      } else {
        hasAccepted = false;
      }
    } catch (_err) {
      // Malformed JSON or non-JSON legacy value
      const trimmed = rawPreference.trim();
      if (trimmed === "true" || trimmed === "false") {
        hasAccepted = trimmed === "true";
      } else if (termsVersion) {
        hasAccepted = trimmed === termsVersion;
      } else {
        hasAccepted = false;
      }
    }
  }

  return {
    loading,
    error,
    data: hasAccepted,
  };
};
